module.exports = __webpack_public_path__ + "static/media/feedbackIcon.b1254930.svg";